var _rect, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 88,
    viewBox: "0 0 81 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 88,
    rx: 32,
    fill: "#4880FF",
    fillOpacity: 0.35
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0002,
    cy: 37,
    rx: 7,
    ry: 8,
    fill: "#4880FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0002 56C53.0002 60.4183 47.1799 59 40.0002 59C32.8205 59 27.0002 60.4183 27.0002 56C27.0002 51.5817 32.8205 46 40.0002 46C47.1799 46 53.0002 51.5817 53.0002 56Z",
    fill: "#4880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainers);
export default __webpack_public_path__ + "static/media/trainers.f9c54fa0b6812e052dfa164f3d3bb3bb.svg";
export { ForwardRef as ReactComponent };